import css from "../../pages/SuspensionPage/SuspensionPage.module.css";
export default function Final() {
  return (
    <div className={css.finalText}>
      <p>
        Choosing the right one depends on your goals: Bilstein shines for
        no-fuss reliability; KW/Öhlins for adjustability and refinement; KONI
        for tunable value. Always match to your vehicle, driving style (daily,
        track, off-road), and springs. Professional installation and alignment
        are key for the best results.
      </p>
      <p>
        What vehicle and use case are you upgrading for? I can narrow it down
        further!
      </p>
    </div>
  );
}
